/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { DemographicAppKeys } from '../../../../../global/models/demographics-model';
import { TcsmEpiApiState } from '../../../../../root/tcsm-model';
import { AnnualEnrollmentKey } from '../../../../annual-enrollment/models/annual-enrollment-models';
import { PersonalInfoWizard } from './personal-info-wizard';

export class PersonalInfoNewHireWizard extends PersonalInfoWizard {

	readonly onSuccess: () => void;

	readonly nonStip: boolean;

	constructor(epiContent: TcsmEpiApiState, enrollmentContext: AnnualEnrollmentKey, app: DemographicAppKeys, dispatch: any, history: any, nonStip: boolean, onSuccess: () => void) {
		super(epiContent, enrollmentContext, app, dispatch, history);
		this.onSuccess = onSuccess;
		this.nonStip = nonStip;
	}

	public getPageDescription(): string {
		return null;
	}

	public getPageHeader(): string {
		return null;
	}

	public useEffectDispatch(): void {
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public onSuccessRedirect(basePath: string): void {
		this.onSuccess();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public onSuccessNoChanges(basePath: string): void {
		this.onSuccess();
	}

	public isEnrollmentForm(): boolean {
		return false;
	}

	public isAnnualEnrollmentForm(): boolean {
		return false;
	}

	public getGpsType(): GpsType {
		return GpsType.NONE;
	}

	public getSubmitButtonText() {
		return this.nonStip ? this.epiContent?.newHireSettingsState?.epiContent?.nonStipContinueButtonText : this.epiContent?.newHireSettingsState?.epiContent?.stipContinueButtonText;
	}

	public getCancelButtonText() {
		return this.epiContent?.newHireSettingsState?.epiContent?.cancelButtonText;
	}

	public hasMaritalStatusSection(): boolean {
		return false;
	}

	public preventButtonDisableValidation(): boolean {
		return true;
	}
}